import { render, staticRenderFns } from "./professionalArticles.vue?vue&type=template&id=270d1fbe&scoped=true"
import script from "./professionalArticles.vue?vue&type=script&lang=js"
export * from "./professionalArticles.vue?vue&type=script&lang=js"
import style0 from "./professionalArticles.vue?vue&type=style&index=0&id=270d1fbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d1fbe",
  null
  
)

export default component.exports